import { api } from './api';

export interface ConnectStatus {
  isConnected: boolean;
  status: string;
  accountId?: string;
  accountType?: 'express' | 'standard';
  chargesEnabled?: boolean;
  payoutsEnabled?: boolean;
  detailsSubmitted?: boolean;
  requiresAction?: boolean;
}

export const stripeConnectApi = {
  getStatus: async (): Promise<ConnectStatus> => {
    const response = await api.get('/stripe-connect/status');
    return response.data;
  },
  getOnboardingUrl: async (): Promise<string> => {
    const response = await api.get('/stripe-connect/onboard');
    return response.data.url;
  },
  getRefreshUrl: async (): Promise<string> => {
    const response = await api.get('/stripe-connect/refresh');
    return response.data.url;
  },
  getOAuthUrl: async (): Promise<string> => {
    const response = await api.get('/stripe-connect/oauth/authorize');
    return response.data.url;
  },
  disconnect: async (): Promise<void> => {
    await api.delete('/stripe-connect/disconnect');
  },
  createPaymentLink: async (invoiceId: string): Promise<{ paymentLinkId: string; paymentLinkUrl: string }> => {
    const response = await api.post(`/stripe-connect/invoices/${invoiceId}/payment-link`);
    return response.data;
  },
};
